import React from "react";
import { Modal } from "react-bootstrap";
import { trimTo } from "src/_config";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useAppGameWiningTruckDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
interface WinningAnswerModalProps {
  shouldShow: boolean;
  closeModal: Function;
  winningData: any;
}

export default function WinningAnswerModal({ shouldShow, closeModal, winningData }: WinningAnswerModalProps) {
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        // onHide={() => closeModal()}
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Header>
          <h2 className="modal-header-text">
            {winningData?.answer_contestant_details?.event_dtls?.event_title} Correct Answer
          </h2>
          <button type="button" className="btn-close btn-close-white" onClick={() => closeModal()}></button>
        </Modal.Header>
        <Modal.Body>
          <div className="success-points-list-content">
            <h4>{winningData?.answer_contestant_details?.question_dtls?.question}</h4>
            <div className="d-flex align-items-center gap-3">
              {/* <div className="avatar">
                <img
                  src="https://d22z93bum7xzz9.cloudfront.net/assets/rqcntst/17325469271370554707.jpg"
                  style={{ width: "100%" }}
                />
              </div> */}
              <h5>{winningData?.answer_contestant_details?.answer_contestant}</h5>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button className="btn btn-primary theme-primary-btn w-100 mt-4" onClick={() => closeModal()}>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
